import { render, staticRenderFns } from "./ImageStandard.vue?vue&type=template&id=49eb2148&scoped=true&"
import script from "./ImageStandard.vue?vue&type=script&lang=js&"
export * from "./ImageStandard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49eb2148",
  null
  
)

export default component.exports